import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MessagingManagement = () => {
  const [selectedProvider, setSelectedProvider] = useState('all');
  const [selectedRoute, setSelectedRoute] = useState('default');
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-medium mb-6">Messaging Management</h1>

      {/* Section 1: Send Bulk SMS */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-medium">Bulk SMS Management</h2>
          <button 
            onClick={() => navigate('/superadmin/messaging/quick-sms')}
            className="bg-[#FF5722] text-white px-4 py-2 rounded-md hover:bg-[#FF5722]/90 transition-colors"
          >
            New Bulk SMS
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Pending</h3>
            <div className="text-2xl font-bold text-[#FF5722]">245</div>
            <p className="text-sm text-gray-600">messages in queue</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Processing</h3>
            <div className="text-2xl font-bold text-blue-600">1,234</div>
            <p className="text-sm text-gray-600">messages being sent</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Completed</h3>
            <div className="text-2xl font-bold text-green-600">5,678</div>
            <p className="text-sm text-gray-600">messages delivered</p>
          </div>
        </div>

        {/* Recent Bulk SMS Table */}
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Batch ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Recipients</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Success Rate</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap">BULK-001</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                    Completed
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">1,000</td>
                <td className="px-6 py-4 whitespace-nowrap">98.5%</td>
                <td className="px-6 py-4 whitespace-nowrap">2023-10-15</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Section 2: SMS Routing and Delivery Control */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-medium">SMS Routing and Delivery Control</h2>
          <button 
            onClick={() => navigate('/superadmin/messaging/routing-parameters')}
            className="bg-[#FF5722] text-white px-4 py-2 rounded-md hover:bg-[#FF5722]/90 transition-colors"
          >
            Set Routing and Delivery Parameters
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Provider Management */}
          <div className="border rounded-lg p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-medium">SMS Providers</h3>
              <button className="text-[#FF5722] hover:text-[#FF5722]/90 text-sm">
                Add Provider
              </button>
            </div>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <div>
                  <p className="font-medium">Provider A</p>
                  <p className="text-sm text-gray-600">Status: Active</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-green-600">98.5% uptime</span>
                  <button className="text-gray-500 hover:text-gray-700">Configure</button>
                </div>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <div>
                  <p className="font-medium">Provider B</p>
                  <p className="text-sm text-gray-600">Status: Active</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-green-600">99.1% uptime</span>
                  <button className="text-gray-500 hover:text-gray-700">Configure</button>
                </div>
              </div>
            </div>
          </div>

          {/* Routing Rules */}
          <div className="border rounded-lg p-4">
            <h3 className="font-medium mb-4">Routing Rules</h3>
            <div className="space-y-3">
              <div className="p-2 bg-gray-50 rounded">
                <div className="flex items-center justify-between">
                  <p className="font-medium">Priority Route</p>
                  <div className="flex items-center space-x-2">
                    <select 
                      value={selectedRoute}
                      onChange={(e) => setSelectedRoute(e.target.value)}
                      className="text-sm border rounded px-2 py-1"
                    >
                      <option value="default">Provider A</option>
                      <option value="alternate">Provider B</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="p-2 bg-gray-50 rounded">
                <div className="flex items-center justify-between">
                  <p className="font-medium">Fallback Route</p>
                  <div className="flex items-center space-x-2">
                    <select className="text-sm border rounded px-2 py-1">
                      <option>Automatic</option>
                      <option>Manual</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Create and Manage Campaigns */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-medium">Campaign Management</h2>
          <button className="bg-[#FF5722] text-white px-4 py-2 rounded-md hover:bg-[#FF5722]/90 transition-colors">
            Create Campaign
          </button>
        </div>

        {/* Campaign Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Active</h3>
            <div className="text-2xl font-bold">3</div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Scheduled</h3>
            <div className="text-2xl font-bold">5</div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Completed</h3>
            <div className="text-2xl font-bold">12</div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Total Sent</h3>
            <div className="text-2xl font-bold">45,678</div>
          </div>
        </div>

        {/* Active Campaigns */}
        <div className="space-y-4">
          <h3 className="font-medium">Active Campaigns</h3>
          <div className="border rounded-lg divide-y">
            <div className="p-4">
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="font-medium">Q4 Promotion</h4>
                  <p className="text-sm text-gray-600">Progress: 45% complete</p>
                </div>
                <div className="flex items-center space-x-2">
                  <button className="text-blue-600 hover:text-blue-800">Edit</button>
                  <button className="text-red-600 hover:text-red-800">Pause</button>
                </div>
              </div>
              <div className="mt-2 h-2 bg-gray-200 rounded-full">
                <div className="h-2 bg-[#FF5722] rounded-full" style={{ width: '45%' }}></div>
              </div>
            </div>
            <div className="p-4">
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="font-medium">Welcome Series</h4>
                  <p className="text-sm text-gray-600">Progress: 78% complete</p>
                </div>
                <div className="flex items-center space-x-2">
                  <button className="text-blue-600 hover:text-blue-800">Edit</button>
                  <button className="text-red-600 hover:text-red-800">Pause</button>
                </div>
              </div>
              <div className="mt-2 h-2 bg-gray-200 rounded-full">
                <div className="h-2 bg-[#FF5722] rounded-full" style={{ width: '78%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagingManagement; 